export default {
  Email: '',
  Password: ''
}
